import {
  Notification,
  NotificationType
} from '@shared/types/notifications.types'
import dayjs from 'dayjs'
import { TFunction } from 'i18next'

export function getNotificationContent(
  notification: Notification,
  t: TFunction
) {
  const { type, titleVariables = {}, bodyVariables = {}, link } = notification
  const { companyName, userName } = titleVariables ?? {}

  let title = ''
  let linkText = ''
  let body = ''

  switch (type) {
    case NotificationType.INVITATION_COMPANY_ACCEPTED:
      title = t('notifications.invitation.company_accepted.title', {
        companyName
      })
      linkText = t('notifications.invitation.company_accepted.link', {
        companyName
      })
      break
    case NotificationType.INVITATION_COMPANY_RECEIVED:
      title = t('notifications.invitation.company_received.title', {
        userName,
        companyName
      })
      linkText = t('notifications.invitation.company_received.link')
      break
    case NotificationType.INVITATION_COMPANY_REJECTED:
      title = t('notifications.invitation.company_rejected.title', {
        companyName
      })
      break
    case NotificationType.INVITATION_USER_RECEIVED:
      title = t('notifications.invitation.user_received.title', { companyName })
      linkText = t('notifications.invitation.user_received.link')
      break
    case NotificationType.INVITATION_USER_RECEIVED_ACCEPTED:
      title = t('notifications.invitation.user_received_accepted.title', {
        companyName
      })
      body = t('notifications.invitation.user_received_accepted.body', {
        date: bodyVariables?.date
          ? dayjs(bodyVariables?.date, 'YYYY-MM-DD').format('DD/MM')
          : ''
      })
      break
    case NotificationType.INVITATION_USER_ACCEPTED:
      title = t('notifications.invitation.user_accepted.title', {
        userName,
        companyName
      })
      break
    case NotificationType.INVITATION_USER_REJECTED:
      title = t('notifications.invitation.user_rejected.title', {
        userName,
        companyName
      })
      break
  }

  return {
    title,
    companyName,
    showLink: Boolean(linkText && link),
    link,
    linkText,
    body
  }
}
